export default {
  severities: 'Severities',
  allSeverities: 'All severities',
  doesIncludeHiddenAlarms: 'Include hidden alarms',
};
